import { render, staticRenderFns } from "./StudioArtists.vue?vue&type=template&id=388bb74c&scoped=true&"
import script from "./StudioArtists.vue?vue&type=script&lang=js&"
export * from "./StudioArtists.vue?vue&type=script&lang=js&"
import style0 from "./StudioArtists.vue?vue&type=style&index=0&id=388bb74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388bb74c",
  null
  
)

export default component.exports